import type { IPhoto } from '../../common/index.js';

export class CalendarPhotosSelector {

    private readonly remainingPhotos: IPhoto[];
    private readonly usedPhotos: Set<IPhoto>;
    private readonly photoMap: Map<string, IPhoto>;

    public constructor(photos: IPhoto[]) {
        this.remainingPhotos = photos.map((photo) => {
            if (photo.faces !== undefined && photo.faces >= 2 && photo.faces <= 5) {
                return { ...photo, rank: (photo.rank ?? 0) + 0.2 };
            }

            return photo;
        });
        this.usedPhotos = new Set<IPhoto>();
        this.photoMap = new Map(photos.map((photo) => [photo.photoId, photo]));
    }

    public getSortedBatch(size: number): IPhoto[] {
        const sortedPhotos = this.remainingPhotos.sort((a, b) => (b.rank ?? 0) - (a.rank ?? 0));

        return sortedPhotos.slice(0, size);
    }

    public updatedPhotoSet(photoId: string): void {
        const photo = this.photoMap.get(photoId);

        if (!photo) {
            return;
        }

        const index = this.remainingPhotos.findIndex((p) => p.photoId === photoId);

        if (index !== -1) {
            this.remainingPhotos.splice(index, 1);
            this.usedPhotos.add(photo);
        }
    }

    public getUsedPhotos(): IPhoto[] {
        return [...this.usedPhotos];
    }

}
